import {RefineProps, ResourceProps} from "@refinedev/core"
import {dataProvider} from "./dataProvider"
import {authProvider} from "./authProvider"
import {i18nProvider} from "./i18nProvider"
import {useNotificationProvider} from "@refinedev/antd"
import routerBindings from "@refinedev/react-router-v6"

const resources: ResourceProps[] = [{
    name: "activity",
    list: "/activity",
    create: "/activity/create",
    edit: "/activity/edit/:id",
    show: "/activity/show/:id",
    meta: {canDelete: true, label: "..."}
}]

export enum provider {
    las = "las",
    lavl = "lavl"
}

const refineConfig = (): RefineProps => {
    return {
        dataProvider: {
            default: dataProvider(window.userprofile.url),
            [provider.las]: dataProvider(window.lascholar.url),
            [provider.lavl]: dataProvider(window.lavirtuallab.url)
        },
        authProvider: authProvider,
        i18nProvider: i18nProvider(),
        notificationProvider: useNotificationProvider,
        routerProvider: routerBindings,
        resources: resources,
        options: {
            syncWithLocation: true,
            title: {
                icon: '/images/la.png',
                text: 'LAAdmin'
            },
            warnWhenUnsavedChanges: true
        }
    }
}

export default refineConfig